<div class="bottom-margin">
  <uni-search [showOptions]="false" placeholder="Search Competitions on UNI" (searchedText)="goToSearchPage($event)">
  </uni-search>
</div>

<ng-container *ngIf="isLoading; else viewCompetitionSections">
  <div fxLayout="row" style="min-height:60vh" fxLayoutAlign="center center">
    <uni-loader></uni-loader>
  </div>
</ng-container>

<ng-template #viewCompetitionSections>
  <ng-container *ngIf="section?.competitions?.length > 0;">
    <div class="width-100 sparro-bg-white border-radius-3 padding-y-3" fxLayout="column" fxLayoutAlign="center center">
      <h1 class="section-title font-bold sparro-grey-900 text-center">{{ section.title }}</h1>
      <h2 class="section-desc sparro-grey-800 text-center" [innerHTML]="section.description | safeContent"></h2>

      <ng-container *ngIf="section.competitions; else loader">
        <uni-competition-cards-group [competitions]="section.competitions" [display]="'grid'" align="center">
        </uni-competition-cards-group>
      </ng-container>

      <ng-template #loader>
        <uni-skeleton-loader appearance="competition" [count]="8" [alignCenter]="true">
        </uni-skeleton-loader>
      </ng-template>
    </div>
  </ng-container>
</ng-template>
<uni-public-footer></uni-public-footer>